import React from 'react';

const ShortButton = ({text, disabled = false, onClick, type = "button", identifier="default-button"}) => {
    return (
      <>
        <style>
        @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
          {`
            .begin-button {
              display: flex;
              padding: 12px 22px 12px 22px;
              width: 122px;
              align-items: center;
              justify-content: center;
              gap: 10px;
              border-radius: 24px;
              border: 1.5px solid #6B3A8F;
              background: rgba(243, 243, 243, 0.10);
              box-shadow: 10px 10px 80px 0px rgba(63, 39, 102, 0.10);
              cursor: pointer;
              backdrop-filter: blur(25px);
            }
  
            .begin-text {
              font-family: 'Poppins', sans-serif;
              font-size: 16px;
              font-style: normal;
              font-weight: 700;
              line-height: 140%;
              text-align: center;
              background: linear-gradient(90deg, #9797FA 0%, #B849D6 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          `}
        </style>
        
        <button 
          className="begin-button"
          onClick={onClick}
          disabled={disabled}
          type={type}
          data-cy={identifier}
        >
          <span className="begin-text">{text}</span>
        </button>
      </>
    );
  };
  export default ShortButton;